export default class IncarnationModel {
    constructor(data = {}) {
        this.id = data.id;
        this.name = data.name;
    }
}
